import React, { Component } from "react";

import Icon from "material-ui-next/Icon";
import IconButton from "material-ui-next/IconButton";

export default class CustomIconButton extends Component {
  state = { hover: false };
  setHover = value => () => this.setState({ hover: value });

  render() {
    const { hover } = this.state;

    const {
      icon,
      onClick,
      hoverColor = "#000000",
      color = "#757575",
      mini = false,
      sizeStyle,
      iconStyle
    } = this.props;

    const style = sizeStyle ? sizeStyle : 48;
    const size = mini ? 38 : style;

    const iconStyle2 = {
      transition: "200ms",
      color: hover ? hoverColor : color,
      ...iconStyle
    };

    return (
      <IconButton
        style={{
          ...this.props.style,
          width: size,
          height: this.props.height || size
        }}
        onClick={onClick}
        onMouseEnter={this.setHover(true)}
        onMouseLeave={this.setHover(false)}
      >
        <Icon style={{ ...this.props.iconStyle, ...iconStyle2 }}>{icon}</Icon>
      </IconButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/support/icon-button/index.jsx